/* eslint-disable react/no-children-prop */
import React, { Fragment } from 'react';
import TittleManger from './titleManager';

const RouterListener: React.FC<{}> = () => (
  <Fragment>
    <TittleManger />
  </Fragment>
);

export default RouterListener;
